// Styles
import './featured-carousel.scss';



if (!window.dAgency) window.dAgency = {};
window.dAgency.initFeaturedCarousel = (context) => {
  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = carousel_banner.querySelector('[data-featured-carousel-master]');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
        snapOnRelease: true
      },
       breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 2,
          spaceBetween: 32
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 40
        }
      }
    });
  }
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.featured-carousel__blocks-container.carousel-container'), (el) => {
    window.dAgency.initFeaturedCarousel(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.featured-carousel__blocks-container.carousel-container'), (el) => {
      window.dAgency.initFeaturedCarousel(el);
    });
  });
}
